var map = {
	"./AI1.jpg": 2041,
	"./AI2.jpg": 542,
	"./AI3.jpg": 699,
	"./AI5.jpg": 9781,
	"./AI7.jpg": 4487,
	"./AI8.jpg": 9332,
	"./AI9.png": 5929,
	"./B2.jpg": 5332,
	"./CC2.jpg": 5586,
	"./CG.png": 6610,
	"./CH.jpg": 5765,
	"./CM1.jpg": 6203,
	"./CN3.jpg": 4020,
	"./CRB.png": 6829,
	"./Cfin.png": 4294,
	"./Chime2.jpg": 3974,
	"./Conveyr.png": 2232,
	"./DS1.jpg": 4450,
	"./DS2.jpg": 2941,
	"./DS3OFF.jpg": 5749,
	"./DS4.jpg": 4291,
	"./DS5.jpg": 9590,
	"./Drive12.jpg": 8671,
	"./Manish.png": 2892,
	"./UGRO.png": 133,
	"./VV1.jpg": 3195,
	"./ai-sm1.jpg": 3732,
	"./ai4.jpg": 5736,
	"./aihc3.jpg": 4802,
	"./diagnostic-laboratory-equipment-and-test-tubes.jpg": 9297,
	"./hc1.jpg": 8622,
	"./hosp1.jpg": 6141,
	"./hym1.jpg": 7859,
	"./hym4.jpg": 7874,
	"./kafeel.png": 9588,
	"./logo.png": 3153,
	"./medical-professional-with-patient-consultation.jpg": 7414,
	"./modern-hospital-ward-with-medical-beds-and-equipme.jpg": 4242,
	"./pathology-lab-technician-analyzing-blood-samples.jpg": 4599,
	"./pharmaceutical-lab-scientists.png": 5349,
	"./pp1.png": 9875,
	"./ribbon/ImgACo.zip": 2746,
	"./ribbon/M1.jpg": 3675,
	"./ribbon/Offer1.png": 9874,
	"./ribbon/Offer2.png": 9609,
	"./ribbon/W1.jpg": 7305,
	"./ribbon/W2.jpg": 3598,
	"./ribbon/delivery.jpg": 3737,
	"./ribbon/hypermarket.jpg": 571,
	"./ribbon/loyalty.jpg": 2007,
	"./sm1.jpg": 8507,
	"./sm4.jpg": 6682
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;